"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VouchesController = function () {
  function VouchesController(VouchesService, FilterService, NotificationService, AuthService, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, VouchesController);
    this.vouchesService = VouchesService;
    this.filterService = FilterService;
    this.authService = AuthService;
    this.notificationService = NotificationService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
  }

  (0, _createClass3.default)(VouchesController, [{
    key: "$onInit",
    value: function $onInit() {
      this.vouchStatusOptions = {
        dataSource: [{ value: 1, text: "Follow-up" }, { value: 2, text: "Complete" }, { value: 3, text: "Incomplete" }],
        dataTextField: "text",
        dataValueField: "value"
      };
    }
  }, {
    key: "getGridOptions",
    value: function getGridOptions() {
      var _this = this;

      return {
        dataSource: this.vouchesService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
        sortable: true,
        pageable: true,
        resizable: true,
        save: this.saveChanges.bind(this),
        height: "90vh",
        // toolbar: [{ name: "create", text: "Create Reference" }],
        noRecords: {
          template: "No References."
        },
        columns: [{
          field: "helperName", title: "Helper Name", filterable: false, attributes: { "class": "col-name" }, width: "4rem",
          template: function template(dataItem) {
            return "<a class=\"cell\" href=\"/users/" + dataItem.jugglerId + "\"><span>" + dataItem.helperName + "</span></a>";
          }
        }, { field: "fullName", title: "Voucher", filterable: false, width: "4rem" }, { field: "interestedInAuPairJobs", title: "Is Au Pair?", filterable: false, width: "2rem", template: function template(dataItem) {
            return "" + (dataItem.interestedInAuPairJobs ? 'Yes' : 'No');
          } }, { field: "status", title: "Status", filterable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getVouchStatus(dataItem.status);
          } }, { field: "referenceType", title: "Type", filterable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getVouchReferenceType(dataItem.referenceType, dataItem.otherReferenceType);
          } }, { field: "email", title: "Email", filterable: false, width: "6rem" }, { field: "phoneNumber", title: "Phone Number", filterable: false, width: "6rem" }, { field: "submissionDate", title: "Submission Date", filterable: false, width: "4rem", template: "#= submissionDate ? kendo.toString(new Date(submissionDate), 'dd-MM-yyyy') : '-' #" }, { title: "Update", command: [{ name: "edit", text: "Update" }], width: "4rem" }],
        editable: {
          mode: "popup",
          window: { title: "Vouch" },
          template: kendo.template($("#popup-editor").html())
        }
      };
    }
  }, {
    key: "saveChanges",
    value: function saveChanges(e) {
      var status = e.model;

      if (status.status == 2 && (!status.whatWouldYouLikeToSay || !status.jugglerId)) {
        this.notificationService.error("Check missing fields and try again.");
        e.preventDefault();
      }
    }
  }, {
    key: "_getVouchStatus",
    value: function _getVouchStatus(status) {
      switch (status) {
        case _constants2.default.vouchStatus.PENDING:
          return "Follow-up";
        case _constants2.default.vouchStatus.APPROVED:
          return "Complete";
        case _constants2.default.vouchStatus.CANCELLED:
          return "Incomplete";
        case _constants2.default.vouchStatus.EXPIRED:
          return "Expired";
        case _constants2.default.vouchStatus.NONE:
          return "-";
      }
    }
  }, {
    key: "_getVouchReferenceType",
    value: function _getVouchReferenceType(status, otherReferenceType) {
      switch (status) {
        case _constants2.default.vouchReferenceType.FAMILY:
          return "Family";
        case _constants2.default.vouchReferenceType.CHILDCAREEMPLOYMENT:
          return "Childcare Employment";
        case _constants2.default.vouchReferenceType.NONCHILDCAREEMPLOYMENT:
          return "Non-childcare Employment";
        case _constants2.default.vouchReferenceType.OTHER:
          return "Other (" + otherReferenceType + ")";
        case _constants2.default.vouchReferenceType.JUGGLESTREET:
          return "Juggle Street";
        case _constants2.default.vouchReferenceType.UNSPECIFIED:
          return "-";
      }
    }
  }, {
    key: "applyFilters",
    value: function applyFilters() {
      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
    }
  }, {
    key: "dataSourceFetchSuccessCallback",
    value: function dataSourceFetchSuccessCallback(e) {
      this.vouchesMatchCount = this.gridOptions.dataSource.total();
      this.$scope.$apply();
    }
  }, {
    key: "dataSourceErrorSuccessCallback",
    value: function dataSourceErrorSuccessCallback(e) {
      var _this2 = this;

      if (e.xhr.status == 401) {
        this.authService.refreshToken().then(function (response) {
          _this2.applyFilters();
        }).catch(function (error) {
          _this2.authService.logout();
        });
      } else {
        this.authService.logout();
      }
    }
  }]);
  return VouchesController;
}();

exports.default = VouchesController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/vouches/vouches.controller.js
 **/